import script from "./WordCloud.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordCloud.vue?vue&type=script&lang=ts&setup=true"

import "./WordCloud.vue?vue&type=style&index=0&id=5f281659&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f281659"]])

export default __exports__